import { render, staticRenderFns } from "./GridCard.vue?vue&type=template&id=0b0911cc&scoped=true"
import script from "./GridCard.vue?vue&type=script&lang=js"
export * from "./GridCard.vue?vue&type=script&lang=js"
import style0 from "./GridCard.vue?vue&type=style&index=0&id=0b0911cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0911cc",
  null
  
)

export default component.exports